class FlowerAvailability {
  constructor(sectionEl) {
    this.container = sectionEl;
    this.init();
  }

  init() {
    const months = [
      { full: "January" },
      { full: "February" },
      { full: "March" },
      { full: "April" },
      { full: "May" },
      { full: "June" },
      { full: "July" },
      { full: "August" },
      { full: "September" },
      { full: "October" },
      { full: "November" },
      { full: "December" },
    ];
    const flowerData = [
      {
        flower: "Agapanthus",
        months: "Year Round",
        url: "/collections/agapanthus",
      },
      {
        flower: "Ageratum",
        months: "June-October",
        url: "/collections/ageratum",
      },
      {
        flower: "Air Plants",
        months: "Year Round",
        url: "/collections/air-plants",
      },
      { flower: "Allium", months: "May-August", url: "/collections/allium" },
      {
        flower: "Alstroemeria",
        months: "Year Round",
        url: "/collections/alstroemeria",
      },
      {
        flower: "Amaranthus",
        months: "Year Round",
        url: "/collections/amaranthus",
      },
      {
        flower: "Amaryllis",
        months: "October-March",
        url: "/collections/amaryllis",
      },
      { flower: "Anemone", months: "Year Round", url: "/collections/anemone" },
      {
        flower: "Anthurium",
        months: "Year Round",
        url: "/collections/anthurium",
      },
      {
        flower: "Artichokes",
        months: "September-October",
        url: "/collections/artichokes",
      },
      {
        flower: "Asclepia",
        months: "April-September",
        url: "/collections/asclepia",
      },
      { flower: "Asters", months: "Year Round", url: "/collections/asters" },
      { flower: "Astilbe", months: "Year Round", url: "/collections/astilbe" },
      {
        flower: "Astrantia",
        months: "Year Round",
        url: "/collections/astrantia",
      },
      {
        flower: "Babys Breath Flower",
        months: "Year Round",
        url: "/collections/babys-breath-flower",
      },
      { flower: "Berries", months: "Year Round", url: "/collections/berries" },
      {
        flower: "Bouvardia",
        months: "Year Round",
        url: "/collections/bouvardia",
      },
      {
        flower: "Branches",
        months: "Year Round",
        url: "/collections/branches",
      },
      { flower: "Buddleia", months: "July", url: "/collections/buddleia" },
      {
        flower: "Calla Lilies Flower",
        months: "Year Round",
        url: "/collections/calla-lilies-flower",
      },
      {
        flower: "Campanulas",
        months: "Year Round",
        url: "/collections/campanulas",
      },
      {
        flower: "Carnations",
        months: "Year Round",
        url: "/collections/carnations",
      },
      { flower: "Celosia", months: "Year Round", url: "/collections/celosia" },
      { flower: "Clematis", months: "July", url: "/collections/clematis" },
      {
        flower: "CornFlower",
        months: "April-November",
        url: "/collections/cornflower",
      },
      {
        flower: "Craspedia Billy Balls",
        months: "Year Round",
        url: "/collections/craspedia-billy-balls",
      },
      {
        flower: "Daffodils",
        months: "December-October",
        url: "/collections/daffodils",
      },
      { flower: "Dahlias", months: "Year Round", url: "/collections/dahlias" },
      {
        flower: "Daisies Poms",
        months: "Year Round",
        url: "/collections/daisies-poms",
      },
      {
        flower: "Delphinium",
        months: "Year Round",
        url: "/collections/delphinium",
      },
      {
        flower: "Dianthus",
        months: "Year Round",
        url: "/collections/dianthus",
      },
      {
        flower: "Dried Flowers",
        months: "Year Round",
        url: "/collections/dried-flowers",
      },
      {
        flower: "Eucalyptus",
        months: "Year Round",
        url: "/collections/eucalyptus",
      },
      {
        flower: "Feverfew",
        months: "Year Round",
        url: "/collections/feverfew",
      },
      {
        flower: "Foxglove",
        months: "April-July",
        url: "/collections/foxglove",
      },
      { flower: "Freesia", months: "Year Round", url: "/collections/freesia" },
      {
        flower: "Garden Roses",
        months: "Year Round",
        url: "/collections/garden-roses",
      },
      {
        flower: "Gardenia",
        months: "Year Round",
        url: "/collections/gardenia",
      },
      {
        flower: "Gerberas",
        months: "Year Round",
        url: "/collections/gerberas",
      },
      {
        flower: "Gladiolus",
        months: "Year Round",
        url: "/collections/gladiolus",
      },
      { flower: "Green", months: "Year Round", url: "/collections/green" },
      {
        flower: "Heather",
        months: "March-September",
        url: "/collections/heather",
      },
      { flower: "Hellebores", months: "May", url: "/collections/hellebores" },
      { flower: "Herbs", months: "Year Round", url: "/collections/herbs" },
      {
        flower: "Hyacinth",
        months: "Year Round",
        url: "/collections/hyacinth",
      },
      {
        flower: "Hydrangeas",
        months: "Year Round",
        url: "/collections/hydrangeas",
      },
      {
        flower: "Hypericum Berry",
        months: "Year Round",
        url: "/collections/hypericum-berry",
      },
      { flower: "Iris", months: "Year Round", url: "/collections/iris" },
      { flower: "Kale", months: "Year Round", url: "/collections/kale" },
      {
        flower: "Kangaroo Paw",
        months: "Year Round",
        url: "/collections/kangaroo-paw",
      },
      { flower: "Lace", months: "Year Round", url: "/collections/lace" },
      {
        flower: "Larkspur",
        months: "Year Round",
        url: "/collections/larkspur",
      },
      { flower: "Liatris", months: "Year Round", url: "/collections/liatris" },
      { flower: "Lilac", months: "January-May", url: "/collections/lilac" },
      { flower: "Lilies", months: "Year Round", url: "/collections/lilies" },
      {
        flower: "Lily Of the Valley",
        months: "Year Round",
        url: "/collections/lily-of-the-valley",
      },
      {
        flower: "Limonium",
        months: "Year Round",
        url: "/collections/limonium",
      },
      {
        flower: "Lisianthus",
        months: "Year Round",
        url: "/collections/lisianthus",
      },
      {
        flower: "Matsumoto",
        months: "Year Round",
        url: "/collections/matsumoto",
      },
      {
        flower: "Marigold",
        months: "September-November",
        url: "/collections/marigold",
      },
      {
        flower: "Monkshood",
        months: "August-November",
        url: "/collections/monkshood",
      },
      { flower: "Mosses", months: "Year Round", url: "/collections/mosses" },
      { flower: "Nigella", months: "Year Round", url: "/collections/nigella" },
      { flower: "Orchids", months: "Year Round", url: "/collections/orchids" },
      { flower: "Peonies", months: "Year Round", url: "/collections/peonies" },
      {
        flower: "Peruvian Lilies",
        months: "Year Round",
        url: "/collections/peruvian-lilies",
      },
      { flower: "Phlox", months: "Year Round", url: "/collections/phlox" },
      { flower: "Pods", months: "Year Round", url: "/collections/pods" },
      {
        flower: "Preserved Roses",
        months: "Year Round",
        url: "/collections/preserved-roses",
      },
      {
        flower: "Ranunculus",
        months: "Year Round",
        url: "/collections/ranunculus",
      },
      {
        flower: "Rice Flower",
        months: "Year Round",
        url: "/collections/rice-flower",
      },
      { flower: "Roses", months: "Year Round", url: "/collections/roses" },
      {
        flower: "Rose Petals",
        months: "Year Round",
        url: "/collections/rose-petals",
      },
      {
        flower: "Sweetheart Roses",
        months: "Year Round",
        url: "/collections/sweetheart-roses",
      },
      {
        flower: "Safflower",
        months: "Year Round",
        url: "/collections/safflower",
      },
      {
        flower: "Scabiosa",
        months: "Year Round",
        url: "/collections/scabiosa",
      },
      {
        flower: "Snapdragon",
        months: "Year Round",
        url: "/collections/snapdragon",
      },
      {
        flower: "Mums Spider Mums",
        months: "Year Round",
        url: "/collections/mums-spider-mums",
      },
      { flower: "Solomio", months: "Year Round", url: "/collections/solomio" },
      {
        flower: "Spray Roses",
        months: "Year Round",
        url: "/collections/spray-roses",
      },
      {
        flower: "Star of Bethlehem",
        months: "Year Round",
        url: "/collections/star-of-bethlehem",
      },
      { flower: "Statice", months: "Year Round", url: "/collections/statice" },
      {
        flower: "Straw Flower",
        months: "Year Round",
        url: "/collections/straw-flower",
      },
      {
        flower: "Succulents",
        months: "Year Round",
        url: "/collections/succulents",
      },
      {
        flower: "Sunflowers",
        months: "Year Round",
        url: "/collections/sunflowers",
      },
      {
        flower: "Sweet Peas",
        months: "Year Round",
        url: "/collections/sweet-peas",
      },
      { flower: "Thistle", months: "Year Round", url: "/collections/thistle" },
      {
        flower: "Trachelium",
        months: "Year Round",
        url: "/collections/trachelium",
      },
      {
        flower: "Tropicals",
        months: "Year Round",
        url: "/collections/tropicals",
      },
      { flower: "Tulips", months: "Year Round", url: "/collections/tulips" },
      {
        flower: "Tweedia",
        months: "April-October",
        url: "/collections/tweedia",
      },
      {
        flower: "Veronica",
        months: "Year Round",
        url: "/collections/veronica",
      },
      {
        flower: "Wax Flower",
        months: "Year Round",
        url: "/collections/wax-flower",
      },
      { flower: "Yarrow", months: "Year Round", url: "/collections/yarrow" },
    ];

    const getMonthsInRange = (range) => {
      if (range.toLowerCase().includes("year round"))
        return months.map((m) => m.full);
      const [start, end] = range.split("-");
      if (!start) return [];
      const startIndex = months.findIndex((m) => m.full === start);
      const endIndex = months.findIndex((m) => m.full === end);
      if (startIndex === -1) return [];
      if (!end || startIndex === endIndex) return [months[startIndex].full];
      if (startIndex < endIndex)
        return months.slice(startIndex, endIndex + 1).map((m) => m.full);

      const endOfYear = months.slice(startIndex).map((m) => m.full);
      const startOfYear = months.slice(0, endIndex + 1).map((m) => m.full);
      return [...endOfYear, ...startOfYear];
    };

    const monthObj = {};
    months.forEach((m) => (monthObj[m.full] = []));

    flowerData.forEach((flower) => {
      const range = getMonthsInRange(flower.months);
      range.forEach((m) => monthObj[m].push(flower));
    });

    for (const monthName in monthObj) {
      const monthEl = this.container.querySelector(
        `.${monthName.toLowerCase()}-month`
      );
      if (!monthEl) continue;

      const listContainer = monthEl.querySelector(".flower-list");
      listContainer.innerHTML = "";

      const flowersInMonth = monthObj[monthName].sort((a, b) =>
        a.flower.localeCompare(b.flower)
      );
      const flowersToShow = flowersInMonth.slice(0, 5);

      flowersToShow.forEach((flower) => {
        const li = document.createElement("li");
        li.innerHTML = `<a target="_blank" href="${flower.url || "#"}">${
          flower.flower
        }</a>`;
        listContainer.append(li);
      });

      if (flowersInMonth.length > 5) {
        const more = document.createElement("li");
        more.classList.add("show-more");
        more.innerHTML = `<a>+ ${flowersInMonth.length - 5} more</a>`;

        more.addEventListener("click", () => {
          this.showDialog(monthName, flowersInMonth);
        });
        listContainer.append(more);
      }
    }
  }

  showDialog(monthName, flowers) {
    const body = document.body;
    body.style.overflow = "hidden";

    const mask = document.createElement("div");
    mask.id = "diy_dialog_mask";

    const dialog = document.createElement("div");
    dialog.id = "diy_dialog";

    const closeButton = document.createElement("div");
    closeButton.innerHTML = `<svg xmlns="http://www.w3.org/2000/svg" class="diy_dialog--close" viewBox="0 0 48 48"><path d="M 38.98 6.97 A 2 2 0 0 0 37.58 7.58 L 24 21.17 L 10.41 7.58 A 2 2 0 0 0 7.58 10.41 L 21.17 24 L 7.58 37.58 A 2 2 0 1 0 10.41 40.41 L 24 26.82 L 37.58 40.41 A 2 2 0 1 0 40.41 37.58 L 26.82 24 L 40.41 10.41 A 2 2 0 0 0 38.98 6.97 z" fill="currentColor"></path></svg>`;

    const allFlowersHtml = flowers
      .map(
        (f) =>
          `<li><a target="_blank" href="${f.url || "#"}">${f.flower}</a></li>`
      )
      .join("");

    dialog.innerHTML = `<h2>${monthName}</h2><ul class="flower-list">${allFlowersHtml}</ul>`;
    dialog.append(closeButton);

    const closeAll = () => {
      body.style.overflow = "";
      dialog.remove();
      mask.remove();
    };

    closeButton.addEventListener("click", closeAll);
    mask.addEventListener("click", closeAll);

    body.append(mask, dialog);
  }
}

document.addEventListener("DOMContentLoaded", function (event) {
  document
    .querySelectorAll(".flower-availability-section")
    .forEach((section) => {
      new FlowerAvailability(section);
    });
});
